import { httpClient } from '@/domains/core/httpClient/httpClient';
import logger from '@/domains/core/observability/logger';
import { getAppSetting } from '@/domains/core/settings/appSettings';
import { getPlatform, isB2B } from '@/domains/core/settings/utils';

import type {
  MsRecommendationResponse,
  RawMSResponse,
} from '../../interfaces/msRecommendation';
import { ABTEST_MS_RECO } from '../../modules/ProductRecommendation/constants';
import type { ProductRecommendationParams } from '../../modules/ProductRecommendation/interfaces/ProductRecommendation.model';

export const getAbTestsPoolsParameter = (abTests: Record<string, boolean>) =>
  ABTEST_MS_RECO.map((id) => (abTests[id] ? 'b' : 'a')).join('');

// @deprecated
export const fetchMsRecommendation = async (
  params: ProductRecommendationParams,
  abTests: Record<number, boolean>,
): Promise<MsRecommendationResponse | undefined> => {
  const url = `${getAppSetting('MS_RECOMMENDATION_KOTLIN_WEB')}/api/v2/recommendation-engines`;
  const {
    categoryId,
    productId,
    modelId,
    pageType,
    productIds,
    categoryIds,
    modelIds,
    withABPools = true,
  } = params;

  const timeout = Number(
    pageType === 'add_to_cart_popin'
      ? getAppSetting('MS_RECOMMENDATION_A2C_POPIN_TIMEOUT')
      : getAppSetting('REQUEST_TIMEOUT'),
  );

  const abTestPools = withABPools ? getAbTestsPoolsParameter(abTests) : 'aaa';
  const options = {
    params: {
      page_type: pageType,
      platform_id: getPlatform().toUpperCase(),
      market: isB2B() ? 'b2b' : 'b2c',
      category_id: categoryId,
      product_id: productId,
      model_id: modelId,
      abtest_pools: abTestPools,
      product_ids: productIds,
      category_ids: categoryIds,
      model_ids: modelIds,
    },
    timeout,
  };

  if (categoryId === undefined) {
    delete options.params.category_id;
  }

  try {
    const response = await httpClient.get<
      RawMSResponse<MsRecommendationResponse>
    >(url, options);
    return response.data.content;
  } catch (error) {
    logger.error(
      new Error(
        `Recommendation error -> response: ${JSON.stringify(error.response)}`,
      ),
    );
    return undefined;
  }
};
